module.exports = __webpack_public_path__ + "media/shape/select-shape-8b6d369b.png";